__turbopack_context__.v({
  "blend": "Iqu0RG_blend",
  "body": "Iqu0RG_body",
  "copy": "Iqu0RG_copy",
  "hand": "Iqu0RG_hand",
  "section": "Iqu0RG_section",
  "title": "Iqu0RG_title",
});
